import React, { useState } from "react";
import axios from "axios";
import API from "../api";
import "./SubirFacturaPDF.css";

const SubirFacturaPDF = () => {
  const [cliente, setCliente] = useState("");
  const [trabajo, setTrabajo] = useState("");
  const [fecha, setFecha] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [mensaje, setMensaje] = useState(null);
  const [tipoMensaje, setTipoMensaje] = useState("success");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!archivo) {
      setMensaje("Debes seleccionar un archivo PDF.");
      setTipoMensaje("error");
      return;
    }

    const formData = new FormData();
    formData.append("cliente", cliente);
    formData.append("trabajo", trabajo);
    formData.append("fecha", fecha);
    formData.append("archivo", archivo);

    try {
      await axios.post(`${API}/facturas-subidas`, formData);
      setMensaje("✅ Factura agregada correctamente.");
      setTipoMensaje("success");
      setCliente("");
      setTrabajo("");
      setFecha("");
      setArchivo(null);
    } catch (error) {
      setMensaje("❌ No se pudo subir la factura.");
      setTipoMensaje("error");
    }
  };

  return (
    <div className="card-formulario">
      <div className="encabezado">
        <h2>📎 Subir Factura PDF</h2>
      </div>

      <form onSubmit={handleSubmit} className="formulario-cuerpo">
        <label>
          👤 Cliente
          <input
            type="text"
            value={cliente}
            onChange={(e) => setCliente(e.target.value)}
            required
          />
        </label>

        <label>
          🧰 Trabajo
          <input
            type="text"
            value={trabajo}
            onChange={(e) => setTrabajo(e.target.value)}
            required
          />
        </label>

        <label>
          📅 Fecha
          <input
            type="date"
            value={fecha}
            onChange={(e) => setFecha(e.target.value)}
            required
          />
        </label>

        <label>
          📎 Archivo PDF
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setArchivo(e.target.files[0])}
            required
          />
        </label>

        {archivo && (
          <div className="nombre-archivo">
            ✅ Archivo: {archivo.name}
          </div>
        )}

        <button type="submit" className="boton-verde">
          📤 Subir Factura
        </button>

        {mensaje && (
          <div className={`mensaje ${tipoMensaje === "success" ? "exito" : "error"}`}>
            {mensaje}
          </div>
        )}
      </form>

      {/* 🔘 BOTONES EXTRA DE NAVEGACIÓN */}
      <div className="botones-navegacion">
        <a href="/" className="boton-secundario">🏠 Inicio</a>
        <a href="/facturas-pdf" className="boton-secundario">📄 Ver Facturas</a>
      </div>
    </div>
  );
};

export default SubirFacturaPDF;
